import { Component, OnInit } from '@angular/core';
import {LocalStorageService} from 'ngx-webstorage';
@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.css']
})
export class ConfirmationComponent implements OnInit {

  constructor(private localStorage:LocalStorageService) { }
  quoteId:String='';
  ngOnInit() {
    this.quoteId=this.localStorage.retrieve('quoteId')
  }

}
